import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    name: yup.string(),
    category_id: yup.object(),
    package_id: yup.object(),
    'group.id': yup.object(),
  });
